import { createRoutine } from 'redux-saga-routines';

export const addBidRoutine = createRoutine('BIDS/ADD');
export const getBidsRoutine = createRoutine('BIDS/GET_ALL');
export const getAdminBidsRoutine = createRoutine('ADMIN/BIDS/GET_ALL');
export const setBidStatusRoutine = createRoutine('BID/SET_STATUS');
